import moment from "moment-timezone";
import { usePage } from "@inertiajs/vue3";

const userTimezone = moment.tz.guess();

export function formatDateTime(dateStr) {
    return new Date(
        moment
            .tz(dateStr, usePage().props?.clinicTimezone)
            .format("YYYY-MM-DDTHH:mm:ss"),
    );
}

export function toHHMMSS(dateObj) {
    if (!dateObj) return null;
    const hh = String(dateObj.getHours()).padStart(2, "0");
    const mm = String(dateObj.getMinutes()).padStart(2, "0");
    const ss = String(dateObj.getSeconds() || 0).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
}

// Cria um Date só para exibir no DatePicker (sem timezone-conversion lógica)
export function fromHHMMSS(str) {
    if (!str) return null;
    const [h, m, s = "0"] = String(str).split(":").map(Number);
    const d = new Date(); // qualquer dia local
    d.setHours(h, m, s || 0, 0); // seta “horário de parede” no relógio local
    return d;
}

export function formatTime(time) {
    const clinicTimezone = usePage().props?.clinicTimezone;
    const clinicTime = moment.tz(time, "HH:mm", clinicTimezone);
    const userTime = clinicTime.clone().tz(userTimezone, true);
    const formattedTime = userTime.format("YYYY-MM-DDTHH:mm:ss");
    return new Date(formattedTime);
}

export function formatDate(dateStr) {
    return moment
        .tz(dateStr, usePage().props?.clinicTimezone)
        .format("YYYY-MM-DD");
}

export const formatDateToDisplay = (dateString, format = "DD/MM/YYYY") => {
    return moment(dateString).format(format).toUpperCase();
};

export const formatDateTimeToDisplay = (
    dateString,
    format = "DD/MM/YYYY HH:mm",
) => {
    return moment(dateString).format(format).toUpperCase();
};

export const formatDateTimeToDisplayUTC = (
    dateString,
    format = "DD/MM/YYYY HH:mm",
) => {
    if (!dateString) return "";
    return moment.utc(dateString).format(format);
};

export function formatTimeToDisplay(date) {
    return moment(date).format("HH:mm");
}

export function formatDateBlog(date) {
    return moment(date).locale("pt-br").format("DD [de] MMM [de] YYYY");
}

export function formatDateString(dateString) {
    if (!dateString) return "";

    const dateOnly = dateString.split("T")[0]; // Remove a parte do tempo
    const [year, month, day] = dateOnly.split("-");
    return `${day}/${month}/${year}`;
}

export function formatDateWithTime(dateStr) {
    return moment
        .tz(dateStr, usePage().props?.clinicTimezone)
        .format("DD/MM/YYYY HH:mm");
}

export function formatDateWithDatetime(dateStr) {
    return moment
        .tz(dateStr, usePage().props?.clinicTimezone)
        .format("DD/MM HH:mm");
}

export function formatDateWithTimeOnly(dateStr) {
    return moment.tz(dateStr, usePage().props?.clinicTimezone).format("HH:mm");
}

export function convertDateFromBackendToFrontend(dateStr) {
    if (!dateStr) return null;
    const userTimezone = moment.tz.guess();
    return new Date(moment.tz(dateStr, userTimezone));
}
export function applyDateToComponentPrimeVue(
    dateStr,
    timezone = moment.tz.guess(),
) {
    if (!dateStr) return null;
    const dateOnly = dateStr.split("T")[0];
    const m = moment.tz(dateOnly, "YYYY-MM-DD", timezone);
    return m.toDate();
}
export function getDefaultInitialDateRangeFilter(from = 7, to = 3) {
    const today = new Date();

    // Start date: 7 days before today at 00:00
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - from);
    startDate.setHours(0, 0, 0, 0); // Set to 00:00:00.000

    // End date: 3 days after today at 00:00
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + to);
    endDate.setHours(0, 0, 0, 0); // Set to 00:00:00.000

    return [startDate, endDate];
}
